<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      :title="title"
      :innerHeight="120"
      :innerScroll="false"
      :qLoading="confirmLoading"
      width="1050px"
      max-height="400px"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <el-form :model="item" size="small" :inline="true" :rules="rules"  :ref="`ruleForm${index}`" label-width="100px" v-loading="loading" v-for="(item,index) in skuList" :key="item.dataId">
        <div>
          <el-form-item label="SKU名称:" prop="name">
          <span>{{item.skuName}}</span>
        </el-form-item>
        </div>
        <el-form-item label="SKU编码" prop="skuCode">
          <el-autocomplete v-if="isRemake"
            class="form-input"
            v-model="item.skuCode"
            :fetch-suggestions="querySkuList"
            @select="handleSelect(item,index)"
            @focus="onSkuCodeFocus(index)"
          ></el-autocomplete>
          <el-input v-else v-model.trim="item.skuCode" @blur="handleSkuCodeModify(index)" />
        </el-form-item>
        <el-form-item label="商品定位" prop="goodsLocation">
          <el-select v-model="item.goodsLocation">
            <el-option :label="item.optionValue" :value="item.id" v-for="item in locationOpt" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="风格" prop="style">
          <el-select v-model="item.style">
            <el-option :label="item.optionValue" :value="item.id" v-for="item in styleList" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有样" prop="sampleFlag">
          <el-select v-model="item.sampleFlag">
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
import {assignValue} from '@/utils'
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: {
    visible: Boolean,
    skuCode: String|Number,
    spuId: String|Number,
    spuType: String|Number,
    skuData: Array
  },
  computed: {
    title() {
      return '修改SKU';
    },
    // 是否翻拍
    isRemake() {
      return +this.spuType === 2;
    }
  },
  data() {
    return {
      dialogVisible: false,
      // 业务
      locationOpt: [],
      styleList: [],
      form: {
        dataId: '',
        spuId: '',
        skuCode: '',
        goodsLocation: '',
        style: '',
        sampleFlag: ''
      },
      rules: {
        skuCode: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      },
      loading: false,
      isSelect: '',
      skuList: [],
      confirmLoading: false,
      updateData: []
    }
  },
  created() {
    console.log(this.skuData);
    this.init();
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.confirmLoading = true;
      let type = true
      this.updateData = []
      for(let i=0 ; i<this.skuList.length;i++) {
        console.log(i);
        console.log(this.skuList);
        this.$refs[`ruleForm${i}`][0].validate(valid => {
        if(!valid) {
          this.confirmLoading = false;
          type = false
        };
        });
        this.updateData.push({
          dataId: this.skuList[i].dataId,
          goodsLocation: this.skuList[i].goodsLocation,
          sampleFlag: this.skuList[i].sampleFlag,
          skuCode: this.skuList[i].skuCode,
          spuId: this.skuList[i].spuId,
          style: this.skuList[i].style,
          isSelect: this.skuList[i].isSelect
        })
      }
      if(!type) {
        return
      }
      const params = {
        data: [
          ...this.updateData
        ]
      }
      this.$q.newProduct.updateSku(params)
        .then(({success}) => {
          if (success) {
            this.$notify.success({
              title: '成功',
              message: '修改SKU成功',
            });
            this.updateVal();
            this.$emit('success', {
              skuCode: this.form.skuCode,
              skuId: this.form.dataId
            });
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    async init() {
      this.skuList = JSON.parse(JSON.stringify(this.skuData))
      this.dialogVisible = this.visible;
      await this.get_goodsAttrLocationSelect();
      await this.getOptionType();
      if (this.skuCode) {
        // this.getSkuInfo();
      }
    },
    // getSkuInfo() {
    //   const params = {
    //     params: {
    //       skuCode: this.skuCode,
    //       spuId: this.spuId
    //     }
    //   };
    //   this.loading = true;
    //   this.$q.newProduct.getSkuRelatedProduts(params)
    //       .then(({data}) => {
    //         if (data) {
    //           assignValue(this.form, data, '');
    //         }
    //       })
    //       .finally(() => {
    //         this.loading = false;
    //       });
    // },
    // (商品属性维护页面搜索)商品定位下拉数据
    get_goodsAttrLocationSelect() {
      return this.$q.goods.goodsAttrLocationSelect().then(res => {
        this.locationOpt = res.data;
      }).catch(console.log);
    },
    // 获取风格下拉选项
    getOptionType() {
      return this.$q.goods.goodsQueryOptionType().then(res => {
        this.styleList = res.data.styleList;
      }).catch(console.log);
    },
    querySkuList(queryString, cb) {
      this.$q.newProduct.querySku({
          params: {
            skuCode: queryString || ''
          }
        })
        .then(({data}) => {
          let results = queryString 
            ? data.filter(item => item.skuCode.toLowerCase().includes(queryString.toLowerCase()))
            : data;
          results = results.map(item => ({
            ...item,
            value: item.skuCode
          }));
          // 调用 callback 返回建议列表的数据
          cb(results);
        });
    },
    handleSkuCodeModify(index) {
      // this.isSelect = '否';
      this.$set(this.skuList[index],'isSelect','否')
    },
    handleSelect(item,index) {
      // this.isSelect = '是';
      this.skuData[index].skuCode = item.value;
      this.$set(this.skuList[index],'isSelect','是')
      // this.$refs.ruleForm.validateField('skuCode');
    },
    onSkuCodeFocus(index) {
      // this.isSelect = '否';
      this.$set(this.skuList[index],'isSelect','否')
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-form-item__label {
    width: 85px !important
  }

  >>> .el-dialog__body{
    max-height: 400px
    overflow-x: hidden
  }
</style>>

